import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { AiUpdateQuestionChangeStrategy } from '../../../../bases';
import { AnswerItem } from '../components';
import styled from '@xstyled/styled-components';
import { getSize, styleVariables } from '@lib/common';
import { MathEnabledTextComponent } from '@lib/common';
import { AiChangeType } from '../../../../../../../ai';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledMatchingAnswersContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  width: 100%;\n"])), getSize('padding8'));
var StyledSubQuestionDescription = styled(MathEnabledTextComponent)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 400;\n  color: #475569;\n  line-height: 1.5;\n  p {\n    margin: 0;\n    display: inline;\n  }\n"])), getSize('typo14'));
var StyledSubQuestionBefore = styled(StyledSubQuestionDescription)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: line-through;\n  background-color: #fef2f2;\n  padding: 0 4px;\n  border-radius: 2px;\n  *,\n  p {\n    text-decoration: line-through !important;\n    color: ", " !important;\n    display: inline;\n  }\n"])), styleVariables.colors.colorErrorBase, styleVariables.colors.colorErrorBase);
var StyledSubQuestionAfter = styled(StyledSubQuestionDescription)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: #f0fdf4;\n  padding: 0 4px;\n  border-radius: 2px;\n  *,\n  p {\n    color: ", " !important;\n    display: inline;\n  }\n"])), styleVariables.colors.colorSuccessBase, styleVariables.colors.colorSuccessBase); // Answer pill styled components — show before/after diff in the pill area

var StyledAnswerPillBefore = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: line-through;\n  background-color: #fef2f2;\n  border-radius: 2px;\n  padding: 0 4px;\n  font-size: inherit;\n  font-weight: 600;\n"])), styleVariables.colors.colorErrorBase);
var StyledAnswerPillAfter = styled.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: #f0fdf4;\n  border-radius: 2px;\n  padding: 0 4px;\n  font-size: inherit;\n  font-weight: 600;\n"])), styleVariables.colors.colorSuccessBase);

function getAnswerText(q, subQuestionId) {
  var _find, _find2;

  var answerId = (_find = ((q === null || q === void 0 ? void 0 : q.correctAnswers) || []).find(function (ca) {
    return ca.subQuestionId === subQuestionId;
  })) === null || _find === void 0 ? void 0 : _find.answerId;
  if (!answerId) return undefined;
  return (_find2 = ((q === null || q === void 0 ? void 0 : q.answers) || []).find(function (a) {
    return a.id.toString() === answerId;
  })) === null || _find2 === void 0 ? void 0 : _find2.description;
}

export var MatchingUpdateQuestionStrategy = /*#__PURE__*/function (_AiUpdateQuestionChan) {
  _inherits(MatchingUpdateQuestionStrategy, _AiUpdateQuestionChan);

  var _super = _createSuper(MatchingUpdateQuestionStrategy);

  function MatchingUpdateQuestionStrategy(context) {
    _classCallCheck(this, MatchingUpdateQuestionStrategy);

    return _super.call(this, context);
  }

  _createClass(MatchingUpdateQuestionStrategy, [{
    key: "renderSubDescription",
    value: function renderSubDescription(desc, beforeDesc, changed) {
      if (changed && beforeDesc != null) {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(StyledSubQuestionBefore, {
            value: beforeDesc
          }), /*#__PURE__*/_jsx(StyledSubQuestionAfter, {
            value: desc
          })]
        });
      }

      return /*#__PURE__*/_jsx(StyledSubQuestionDescription, {
        value: desc
      });
    }
  }, {
    key: "renderAnswerPill",
    value: function renderAnswerPill(afterText, beforeText) {
      if (!afterText && !beforeText) return undefined;
      var changed = afterText !== beforeText;

      if (changed && beforeText && afterText) {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(StyledAnswerPillBefore, {
            children: beforeText
          }), ' ', /*#__PURE__*/_jsx(StyledAnswerPillAfter, {
            children: afterText
          })]
        });
      }

      return afterText !== null && afterText !== void 0 ? afterText : beforeText;
    }
  }, {
    key: "renderSubQuestions",
    value: function renderSubQuestions() {
      var _before$subQuestions,
          _after$subQuestions,
          _this = this;

      var before = this.context.before;
      var after = this.context.after;
      var changeType = this.context.changeType;
      var subQuestionsToDisplay = changeType === AiChangeType.Delete ? (_before$subQuestions = before === null || before === void 0 ? void 0 : before.subQuestions) !== null && _before$subQuestions !== void 0 ? _before$subQuestions : [] : (_after$subQuestions = after === null || after === void 0 ? void 0 : after.subQuestions) !== null && _after$subQuestions !== void 0 ? _after$subQuestions : [];
      if (subQuestionsToDisplay.length === 0) return null;
      return /*#__PURE__*/_jsx(StyledMatchingAnswersContainer, {
        children: subQuestionsToDisplay.map(function (sub, idx) {
          var _before$subQuestions2, _sub$description;

          var beforeSub = before === null || before === void 0 ? void 0 : (_before$subQuestions2 = before.subQuestions) === null || _before$subQuestions2 === void 0 ? void 0 : _before$subQuestions2.find(function (bs) {
            return bs.id.toString() === sub.id.toString();
          });
          var subChanged = !!beforeSub && beforeSub.description !== sub.description;
          var afterAnswerText = getAnswerText(after, sub.id.toString());
          var beforeAnswerText = getAnswerText(before, sub.id.toString());
          return /*#__PURE__*/_jsx(AnswerItem, {
            index: ((after === null || after === void 0 ? void 0 : after.index) || 1) + idx,
            values: {
              description: _this.renderSubDescription((_sub$description = sub.description) !== null && _sub$description !== void 0 ? _sub$description : '', beforeSub === null || beforeSub === void 0 ? void 0 : beforeSub.description, subChanged),
              isSelected: !!afterAnswerText || !!beforeAnswerText,
              answerPill: _this.renderAnswerPill(afterAnswerText, beforeAnswerText)
            }
          }, sub.id.toString());
        })
      });
    }
  }]);

  return MatchingUpdateQuestionStrategy;
}(AiUpdateQuestionChangeStrategy);